import Options from './Options';

function Question({ question, dispatch, answer }) {
	return (
		<div>
			<h4>{question.question}</h4>
			{question.tip && (<h5 className="question-tip">Tip: {question.tip}</h5>)}
			<Options question={question} dispatch={dispatch} answer={answer} />
		</div>
	);
}

export default Question;
